


export module Utils{

    export type Listener<T> = (val: T) => void;
    export type Unsubscriber = () => void;

    export class Observable<T> {
        private _listeners: Listener<T>[] = [];
        
        notify(val?:T){
            this._listeners.forEach(l => l(val));
        }
        subscribe(listener: Listener<T>): Unsubscriber  {
            this._listeners.push(listener);
            return () => {
                this._listeners = this._listeners.filter(l => l !== listener);
            };
        }

    }
    export class ValueObservable<T> {
        private _listeners: Listener<T>[] = [];

        constructor(private _val?: T) {}


        get(): T {
            return this._val;
        }

        set(val: T) {
            if (this._val !== val) {
                this._val = val;
                this._listeners.forEach(l => l(val));
            }
        }

        subscribe(listener: Listener<T>): Unsubscriber {
            this._listeners.push(listener);
            return () => {
                this._listeners = this._listeners.filter(l => l !== listener);
            };
        }
    }
    export function StackTrace() {
        try {
          var err = new Error();
          throw err;
        } catch (err) {
          return err.stack;
        }
    }
    export function ReplaceAllInString(str:string,find:string,replaceWith:string){
        var re = new RegExp(find, "g");
        return str.replace(re, replaceWith)
    }
    export function CapitalizeFirstLetter(string:string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    export function RemoveFromArray(item,array){
        var index = array.indexOf(item);
        if (index > -1) {
            array.splice(index, 1);
            return true;
        }
        return false;
    }
    export function AddToArrayIfNotThere(item,array){
        var index = array.indexOf(item);
        if (index > -1) {
            return false;
        }else{
            array.push(item);
            return true;
        }
        
    }
    
    function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }
    export function rgbToHex(r, g, b) {
        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
    }
    export function hsvToRgb(h, s, v) {
        h = h/ 360;
        s = s/ 100;
        v = v/100;
        var r, g, b;
      
        var i = Math.floor(h * 6);
        var f = h * 6 - i;
        var p = v * (1 - s);
        var q = v * (1 - f * s);
        var t = v * (1 - (1 - f) * s);
      
        switch (i % 6) {
          case 0: r = v, g = t, b = p; break;
          case 1: r = q, g = v, b = p; break;
          case 2: r = p, g = v, b = t; break;
          case 3: r = p, g = q, b = v; break;
          case 4: r = t, g = p, b = v; break;
          case 5: r = v, g = p, b = q; break;
        }
      
        return [ Math.round(r * 255), Math.round(g * 255), Math.round(b * 255) ];
      }
      export function rgbToHsv(r, g, b){
        r = r/255, g = g/255, b = b/255;
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
    
        var d = max - min;
        s = max == 0 ? 0 : d / max;
    
        if(max == min){
            h = 0; // achromatic
        }else{
            switch(max){
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
    
        return [Math.round(h * 360), Math.round(s * 100), Math.round(v* 100)];
    }
    export function RoundTo2Decimals(num){
        return Math.round((num + Number.EPSILON) * 100) / 100;
    }
    export async function WaitAsync(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    /**
     * Simple object check.
     * @param item
     * @returns {boolean}
    */
    export function isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }
    
    /**
     * Deep merge two objects.
     * @param target
     * @param ...sources
     */
    export function mergeDeep(target, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();
    
        if (isObject(target) && isObject(source)) {
            for (const key in source) {
                if (isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }
    
        return mergeDeep(target, ...sources);
    }

    // dates
    export var DayOfWeekNames = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
    export var DayOfWeekNameShort = ["SUN","MON","TUE","WED","THU","FRI","SAT"];
    export var MonthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    export var MonthNamesShort = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

    export var DayInMs = 86400000;

    export function NumberOfDaysBetweenDates(date1:Date,date2:Date){
        var difference = date2.getTime() - date1.getTime() ;
        return  Math.ceil(difference / (1000 * 3600 * 24));
    }
    export function DatesAreOnTheSameDay(date1:Date,date2:Date){
        return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
    }
    export function DateAreSameHoursAndMinutes(date1:Date,date2:Date){
        return date1.getHours() === date2.getHours() && date1.getMinutes() === date2.getMinutes();
    }
    export function DatesAreInTheSameMonth(date1:Date,date2:Date){
        var sameYear = date1.getFullYear() == date2.getFullYear();
        return sameYear && date1.getMonth() == date2.getMonth();
    }
    export function DateSameDayAsMs(date:Date,date2:number){
        return date2 > date.getTime() && date2 < (date.getTime()  + DayInMs)
    }
    export function GetTimeStrFromDate(date:Date){
        
        return  date.toLocaleString('en-US', { hour: 'numeric', hour12: true,minute:"2-digit" })
    
    }
    export function GetShortTimeStrFromDate(date:Date){
        return Utils.ReplaceAllInString(Utils.ReplaceAllInString(GetTimeStrFromDate(date),"M","")," ","")
    
    }
    export function GeMicroTimeStrFromDate(date:Date){
        return Utils.ReplaceAllInString(Utils.ReplaceAllInString(Utils.ReplaceAllInString(GetTimeStrFromDate(date),"M","")," ",""),":00","")
    
    }
    export function GetDateString(date:Date){
        return MonthNamesShort[date.getMonth()] + " " + date.getDate() + " " + date.getFullYear()
    
    }
    export function Round(input, digits){
        var rounded = Math.pow(10, digits);
        var str =  (Math.round(input * rounded) / rounded).toFixed(digits);
        return parseFloat(str);
    }
    export var EmptyImgSrc = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=`;



    export function DevEnableAutoLoad(){
        console.log("DevEnableAutoLoad",process.env.REFRESHPORT,process.env.ENV)
        if (process.env.REFRESHPORT && process.env.ENV == "development") {
            console.log("starting event",`http://localhost:${process.env.REFRESHPORT}`)
            const evtSource = new EventSource(`http://localhost:${process.env.REFRESHPORT}`)
        
            evtSource.addEventListener('reload', () => {
              console.log('reload from server')
              window.location.reload()
            })
        
        }else{
        
              console.warn('Missing refresh port. App will not reload after edit!')
        
        }
    }


}





